/**
 * IME風タイピングアニメーション
 * ローマ字 → ひらがな → 漢字変換を再現
 */
export const typingAnimation = () => {
  const catchEl = document.querySelector(".p-top-intro__catch");
  if (!catchEl || typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

  const wrapEl = catchEl.closest(".p-top-intro__catch-wrap");
  if (!wrapEl) return;

  const originalHTML = catchEl.innerHTML;

  // 各行 = セグメント配列、各セグメント = キーストロークごとの表示フレーム配列
  // 最終フレーム = 確定文字（漢字変換含む）
  const lines = [
    // 私たちは、
    [
      ["w", "わ", "わt", "わた", "わたs", "わたsh", "わたし", "私"],
      ["t", "た", "たc", "たch", "たち"],
      ["h", "は"],
      ["、"],
    ],
    // 会計の力で経営を支え、
    [
      ["k", "か", "かい", "かいk", "かいけ", "かいけい", "会計"],
      ["n", "の"],
      ["c", "ch", "ち", "ちk", "ちか", "ちかr", "ちから", "力"],
      ["d", "で"],
      ["k", "け", "けい", "けいえ", "けいえい", "経営"],
      ["w", "を"],
      ["s", "さ", "さs", "ささ", "ささえ", "支え"],
      ["、"],
    ],
    // 未来をつくります。
    [
      ["m", "み", "みr", "みら", "みらい", "未来"],
      ["w", "を"],
      ["t", "ts", "つ", "つk", "つく", "つくr", "つくり", "つくりm", "つくりま", "つくりまs", "つくります"],
      ["。"],
    ],
  ];

  // フレームをフラット配列に展開
  const frames = [];
  const completedLines = [];

  for (const line of lines) {
    let confirmed = "";

    for (const segment of line) {
      for (let i = 0; i < segment.length; i++) {
        const isLast = i === segment.length - 1;
        frames.push({
          completedLines: [...completedLines],
          confirmed,
          composing: isLast ? "" : segment[i],
          fresh: isLast ? segment[i] : "",
          isConversion: isLast && segment.length > 2,
        });
      }
      confirmed += segment.at(-1);
    }
    completedLines.push(confirmed);
  }

  // 約物（句読点）を -yakuhan span で囲む
  const wrapYakuhan = (text) => text.replace(/([、。])/g, '<span class="-yakuhan">$1</span>');

  // 描画関数
  const render = (index) => {
    const f = frames[index];
    let html = "";

    if (f.completedLines.length) {
      html += f.completedLines.map(wrapYakuhan).join("<br>") + "<br>";
    }

    html += wrapYakuhan(f.confirmed);

    if (f.composing) {
      html += `<span class="-composing">${f.composing}</span>`;
    }
    if (f.fresh) {
      html += wrapYakuhan(f.fresh);
    }

    html += '<span class="-typing-cursor"></span>';
    catchEl.innerHTML = html;
  };

  // レイアウトシフト防止: 元の高さを保持
  wrapEl.style.minHeight = `${wrapEl.offsetHeight}px`;
  // CSS側の .is-typing-ready で visibility: hidden を適用（ちらつき防止）
  catchEl.classList.add("is-typing-ready");

  // GSAP タイムライン
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: wrapEl,
      start: "top 70%",
      once: true,
    },
  });

  const KEYSTROKE = 0.045;
  const CONVERT_PAUSE = 0.13;
  const LINE_PAUSE = 0.23;
  let t = 0;

  // 開始: テキストをクリアしてカーソル表示
  tl.call(
    () => {
      catchEl.innerHTML = '<span class="-typing-cursor"></span>';
      catchEl.classList.remove("is-typing-ready");
      catchEl.classList.add("is-typing-active");
    },
    null,
    t,
  );
  t += 0.25;

  // 各フレームをタイムラインに配置
  for (let i = 0; i < frames.length; i++) {
    if (i > 0 && frames[i].completedLines.length > frames[i - 1].completedLines.length) {
      t += LINE_PAUSE;
    }

    tl.call(() => render(i), null, t);
    t += KEYSTROKE;

    if (frames[i].isConversion) {
      t += CONVERT_PAUSE;
    }
  }

  // アニメーション完了後、元のHTMLを復元
  tl.call(
    () => {
      catchEl.classList.remove("is-typing-active");
      catchEl.innerHTML = originalHTML;
      wrapEl.style.minHeight = "";
    },
    null,
    t + 0.7,
  );
};
